import React from 'react'
import { SimpleGrid, Box } from '@chakra-ui/react'
import { CalendarDay } from './CalendarDay'

export const CalendarGrid = ({ calendarDays, simulatedDate }) => {
  const today = simulatedDate || new Date()

  return (
    <SimpleGrid columns={7} spacing={0}>
      {calendarDays &&
        calendarDays.map((dayInfo, index) => {
          const isToday =
            dayInfo.date.getDate() === today.getDate() &&
            dayInfo.date.getMonth() === today.getMonth() &&
            dayInfo.date.getFullYear() === today.getFullYear()

          return <CalendarDay key={index} dayInfo={dayInfo} isToday={isToday} />
        })}
    </SimpleGrid>
  )
}
